
import React from 'react';
import Feature from '../../components/feature/Feature';
import './whatCodely.css';

const WhatCodely = () => (
  <div className="codely__whatcodely section__margin" id="wcodely">
    <div className="codely__whatcodely-feature">
      <Feature title="What is Codely" text="Codely is an intuitive app designed to help you master coding interviews with ease. It offers a curated selection of over 100 practice questions, covering both theoretical concepts and practical scenarios across 5 popular programming languages: C, Java, JavaScript, C++, and SQL. Whether you're a beginner or an experienced developer, Codely provides a focused environment to sharpen your problem-solving skills and deepen your understanding of key topics." />
    </div>
    <div className="codely__whatcodely-heading">
      <h1 className="gradient__text">The possibilities are beyond your imagination</h1>
    </div>
    <div className="codely__whatcodely-container">
      <Feature title="AI Generated Levels" text="Random tests generated by our AI that will help you practice what you learn." />
      <Feature title="Over 100 Levels" text="Over 100 Levels that you can choose from , with 5 different programming languages and more to come" />
      <Feature title="Every programming language" text="From C , to Python or Javascript , every language is sure to be available in the future in Codely" />
    </div>
  </div>
);

export default WhatCodely;
